import React from 'react';
import { Users } from 'lucide-react';
import MainPanel from '../../components/layout/MainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';
import { stringHueColor } from '../../utils/workspaceFormat';

function initials(name) {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return (parts[0] || '?').slice(0, 2).toUpperCase();
}

export default function ReportsAgents() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const agents = data?.workspace?.agents || [];

  return (
    <MainPanel variant="reports" title={t('reports.agentsTitle')} subtitle={t('reports.agentsSubtitle')}>
      {agents.length === 0 ? (
        <div className="reports-agents-empty">
          <Users size={40} strokeWidth={1.25} style={{ margin: '0 auto 16px', color: '#a78bfa', display: 'block' }} aria-hidden />
          <strong>{t('reports.agentsEmpty')}</strong>
          <p style={{ margin: '12px 0 0', color: '#6b7280', fontWeight: 400 }}>{t('reports.agentsEmptyBody')}</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {agents.map((a) => (
            <div
              key={a.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 14,
                padding: '18px 22px',
                borderRadius: 16,
                background: '#fff',
                border: '1px solid #e5e7eb',
                boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
              }}
            >
              <div
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: '50%',
                  background: stringHueColor(a.email || a.fullName),
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 700,
                  fontSize: 14,
                  color: '#fff',
                }}
              >
                {initials(a.fullName)}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700 }}>{a.fullName}</div>
                <div style={{ fontSize: 13, opacity: 0.75, marginTop: 4 }}>{a.email}</div>
              </div>
              <span style={{ fontSize: 12, fontWeight: 600, textTransform: 'capitalize' }}>{a.status}</span>
            </div>
          ))}
        </div>
      )}
    </MainPanel>
  );
}
